//*************** Show Quiz Result on load ***************/
const windowUrl = window.location.href;
const quizObj = sessionStorage.getItem("quizObj");
if (
  windowUrl.indexOf("/pages/quiz") > -1 &&
  windowUrl.indexOf("ContactFooter") > -1 &&
  quizObj
) {
  const dataObj = JSON.parse(quizObj);
  console.log(dataObj, windowUrl);
  let count = 0;
  dataObj.forEach((data, index) => {
    console.log("without condition", data.key, data.value, index);
    if (index < 3) {
      if (index == 0) {
        const mainProduct = document.querySelector(
          `.quiz-product-main-product[data-handle="${data.key}"]`
        );
        mainProduct.style.display = "grid";
      }
      if (index > 0 && data.value > 0) {
        console.log("quiz-product-upsell-block", data.value, index);
        count += 1;
        const upSellProduct = document.querySelector(
          `.quiz-product-upsell-block[data-handle="${data.key}"]`
        );
        upSellProduct.style.display = "block";
      }
    }
  });
  if (!count) {
    document.querySelector(".quiz-product-upsell-wrapper").style.display =
      "none";
  }
  const quizWrapper = document.querySelector(".quiz-wrapper");
  quizWrapper.classList.add("show-products");
}

/*************** Progress bar code ***************/
const progressBar = document.getElementById("progressBar");
const progressPoint = document.getElementById("progressPoint");
let progress = 0;
const step = 10; // Increase by 20% for each step
const maxProgress = 100;
function updateProgress(tabNumber) {
  progress = step * tabNumber;
  progressBar.style.width = `${progress}%`;
  progressPoint.style.left = `${progress}%`;
}

/*************** Range slider animation ***************/
const rangeSlider = document.getElementById("rangeSlider");
console.log(rangeSlider);
const rangeFill = document.querySelector(".range-fill");
function updateSlider() {
  const value = rangeSlider.value;
  const max = rangeSlider.max;
  const min = rangeSlider.min;
  const percentage = ((value - min) / (max - min)) * 100;
  rangeFill.style.width = `${percentage}%`;
}
updateSlider();
rangeSlider.addEventListener("input", updateSlider);

/*************** Wizard tab switch code ***************/
const tabContents = document.querySelectorAll(".quiz-step-wrapper");
const tabsContentWrapper = document.querySelector(".quiz-steps-container");
const prevButton = document.querySelectorAll(".quiz-prev-btn");
const nextButton = document.querySelectorAll(".quiz-next-btn");
const quizOptionInput = document.querySelectorAll(".quiz-option input");
const quizButton = document.querySelectorAll(".quiz-option button");
const SubmitButton = document.querySelector(".quiz-submit-btn");
let customStep;
let optionType;
let activeTab = 1; // Keep track of the active tab
var quiz_banner_button = document.querySelector(
  ".quiz-hero-banner .hero-button"
);
updateActiveTab(1);
// quiz_banner_button.addEventListener("click", function (event) {
//   // alert(1);
//   event.preventDefault();
//   // document.querySelector(".quiz-hero-banner").style.display = "none";
//   // document.querySelector(".quiz-landing-page").style.display = "block";
//   updateActiveTab(activeTab);
// });

var windowURL = window.location.href;
if (windowUrl.indexOf("/pages/quiz") > -1 &&
  windowUrl.indexOf("ContactFooter") > -1 &&
  quizObj) {
  document.querySelector(".quiz-hero-banner").style.display = "none";
  document.querySelector(".quiz-landing-page").style.display = "block";
}

var count = 0;
function updateProductCount(
  inputValue,
  productHandle,
  valueArray,
  point,
  productTracker
) {
  valueArray.forEach(function (value) {
    if (inputValue === value) {
      productTracker[productHandle] =
        parseInt(productTracker[productHandle]) + point;
    }
  });
}

function updateProductTracker(
  inputValue,
  stepNumber,
  stepType,
  productTracker
) {
  const sugarSiftPoint = [
    "Less than 3 times a week",
    "As general support for good health/looking for a good daily probiotic.",
    "Carnivore",
    "Vegan",
    "Ketogenic",
    "Once or twice a week",
    "A few times a month",
    "Rarely/Never",
    "Bowel Regularity",
    "Inflammation",
    "Energy",
    "Detoxification",
  ];
  const idealImmunityPoint = [
    "As general support for good health/looking for a good daily probiotic.",
    "Vegetarian",
    "Pescatarian",
    "Daily",
    "Once or twice a week",
    "Immune Support",
  ];
  const simpleSlumberPoint = ["Falling Asleep/Staying Asleep"];
  const antibioticAntidotePoint = ["Post-Antibiotic Recovery"];
  const heartCenteredPoint = ["Cardiovascular Health"];
  const perfectPeacePoint = ["Mood", "Stress"];
  if (stepNumber == "5" && stepType == "b") {
    updateProductCount(
      inputValue,
      "sugar-shift",
      sugarSiftPoint,
      3,
      productTracker
    );
    updateProductCount(
      inputValue,
      "ideal-immunity",
      idealImmunityPoint,
      3,
      productTracker
    );
    updateProductCount(
      inputValue,
      "simple-slumber",
      simpleSlumberPoint,
      3,
      productTracker
    );
    updateProductCount(
      inputValue,
      "antibiotic-antidote",
      antibioticAntidotePoint,
      3,
      productTracker
    );
    updateProductCount(
      inputValue,
      "heart-centered",
      heartCenteredPoint,
      3,
      productTracker
    );
    updateProductCount(
      inputValue,
      "perfect-peace",
      perfectPeacePoint,
      3,
      productTracker
    );
  } else {
    updateProductCount(
      inputValue,
      "sugar-shift",
      sugarSiftPoint,
      1,
      productTracker
    );
    updateProductCount(
      inputValue,
      "ideal-immunity",
      idealImmunityPoint,
      1,
      productTracker
    );
    updateProductCount(
      inputValue,
      "simple-slumber",
      simpleSlumberPoint,
      1,
      productTracker
    );
    updateProductCount(
      inputValue,
      "antibiotic-antidote",
      antibioticAntidotePoint,
      1,
      productTracker
    );
    updateProductCount(
      inputValue,
      "heart-centered",
      heartCenteredPoint,
      1,
      productTracker
    );
    updateProductCount(
      inputValue,
      "perfect-peace",
      perfectPeacePoint,
      1,
      productTracker
    );
  }
}

async function sendDataToKlaviyo(productTracker, email) {
  const sortedProduct = Object.keys(productTracker)
    .map((key) => ({ key, value: productTracker[key] }))
    .sort((a, b) => b.value - a.value);

  if (sortedProduct[0]?.key) {
    // const nonZeroProducts = Object.entries(productTracker)
    //   .filter(([key, value]) => value !== 0)
    //   .map(([key]) => key);

    // API URL
    const API_URL = "https://a.klaviyo.com/client/profiles?company_id=RuDnU4";

    // Request options
    const options = {
      method: "POST",
      headers: {
        Accept: "application/vnd.api+json",
        "Content-Type": "application/vnd.api+json",
        Revision: "2025-01-15",
      },
      body: JSON.stringify({
        data: {
          type: "profile",
          attributes: {
            properties: {
              quiz_recommanded_product: sortedProduct[0]?.key || "",
            },
            email: email,
          },
        },
      }),
    };

    try {
      const response = await fetch(API_URL, options);

      if (!response.ok) {
        throw new Error(
          `HTTP Error: ${response.status} - ${response.statusText}`
        );
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  }
}

SubmitButton.addEventListener("click", function () {
  const productTracker = {
    "sugar-shift": 0,
    "ideal-immunity": 0,
    "simple-slumber": 0,
    "antibiotic-antidote": 0,
    "heart-centered": 0,
    "perfect-peace": 0,
  };

  tabContents.forEach(function (content) {
    const inputs = content.querySelectorAll("input:checked");
    inputs.forEach(function (input) {
      const inputValue = input?.value;
      const stepNumber = content.dataset?.step;
      const stepType = content.dataset?.type;
      console.log(stepNumber, stepType);
      if (inputValue) {
        console.log(inputValue);
        updateProductTracker(inputValue, stepNumber, stepType, productTracker);
      }
    });
  });

  const sortedProduct = Object.keys(productTracker)
    .map((key) => ({ key, value: productTracker[key] }))
    .sort((a, b) => b.value - a.value);

  // Store Quiz Result in "quizObj" Session
  sessionStorage.setItem("quizObj", JSON.stringify(sortedProduct));

  // Code to validate email id and sotre the Email in shopify customer in "Quiz" Tag
  const newsletterButton = document.querySelector(".newsletter-form__button");
  const emailValue = document.querySelector(
      ".newsletter-form__field-wrapper .field__input"
    ).value,
    emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (emailRegex.test(emailValue) && emailValue.length) {
    sendDataToKlaviyo(productTracker, emailValue);
    document.querySelector(".newsletter-error").style.display = "none";
    newsletterButton.click();
  } else {
    document.querySelector(".newsletter-error").style.display = "block";
  }
});

quizOptionInput.forEach(function (option) {
  option.addEventListener("change", function () {
    const parent = option.closest(".quiz-step-wrapper");
    if (!parent.classList.contains("option-selected")) {
      parent.classList.add("option-selected");
    }
  });
});

quizButton.forEach(function (button) {
  button.addEventListener("click", function () {
    if (button.dataset.value == "Yes") {
      customStep = 9;
      updateProgress(9);
      updateActiveTab(9);
    } else {
      customStep = 8;
      updateProgress(10);
      updateActiveTab(10);
    }
  });
});

prevButton.forEach((button) => {
  button.addEventListener("click", () => {
    const closestParent = button.closest(".quiz-step-wrapper");
    let stepNumber = parseInt(closestParent.dataset.step);
    console.log(stepNumber);
    if (stepNumber == 10) {
      updateProgress(customStep);
      updateActiveTab(customStep);
    } else {
      updateProgress(stepNumber - 1);
      updateActiveTab(stepNumber - 1);
    }
  });
});

nextButton.forEach((button) => {
  button.addEventListener("click", () => {
    const closestParent = button.closest(".quiz-step-wrapper");
    const tabNumber = parseInt(closestParent.dataset.step);
    if (
      !closestParent.classList.contains("option-selected") &&
      tabNumber != 9 &&
      tabNumber != 2
    ) {
      return false;
    }
    const inputValue = closestParent
      .querySelector("input:checked")
      ?.value.trim();
    updateProgress(tabNumber + 1);
    updateActiveTab(tabNumber + 1, inputValue);
  });
});

function updateActiveTab(tabNumber, inputValue) {
  // Update content visibility with slide transition
  tabContents.forEach((content, index) => {
    const tabIndex = parseInt(content.dataset.step);
    const tabType = content.dataset?.type;
    if (
      inputValue ==
      "As general support for good health/looking for a good daily probiotic."
    ) {
      optionType = "a";
    } else if (inputValue == "To address specific issue(s)") {
      optionType = "b";
    }
    if (tabIndex === tabNumber) {
      if (tabType) {
        if (optionType == tabType) {
          var contentHeight = content.scrollHeight;
          tabsContentWrapper.style.height = `${contentHeight}px`;
          content.classList.add("active");
          content.classList.remove("hidden-left", "hidden-right");
        } else {
          content.classList.remove("active");
        }
      } else {
        var contentHeight = content.scrollHeight;
        tabsContentWrapper.style.height = `${contentHeight}px`;
        content.classList.add("active");
        content.classList.remove("hidden-left", "hidden-right");
      }
    } else if (tabIndex < tabNumber) {
      content.classList.remove("active");
      content.classList.add("hidden-left");
      //   console.log("b");
    } else {
      content.classList.remove("active");
      content.classList.add("hidden-right");
      //   console.log("c");
    }
  });
  activeTab = tabNumber; // Update the active tab
}
